
import React from "react";
import { Shell } from "@/components/layout/Shell";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { ImportanceColorSettings } from "@/components/profile/ImportanceColorSettings";
import { UserCompanyRegisterSettings } from "@/components/profile/UserCompanyRegisterSettings";
import { DefaultCurrencySettings } from "@/components/profile/DefaultCurrencySettings";
import { SubscriptionsSection } from "@/components/settings/SubscriptionsSection";
import { ExchangeRateSettings } from "@/components/profile/ExchangeRateSettings";
import { PlanSelectDialog } from "@/components/settings/PlanSelectDialog";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = React.useState("general");

  return (
    <Shell className="p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Manage your account settings and preferences.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="subscription">Subscription</TabsTrigger>
          <TabsTrigger value="appearance">Appearance</TabsTrigger>
          <TabsTrigger value="integrations">Integrations</TabsTrigger>
        </TabsList>
        
        <TabsContent value="general">
          <div className="space-y-6">
            <Card className="p-6">
              <DefaultCurrencySettings />
            </Card>
          </div>
        </TabsContent>
        
        <TabsContent value="subscription">
          <div className="space-y-6">
            <SubscriptionsSection />
          </div>
          <PlanSelectDialog />
        </TabsContent>
        
        <TabsContent value="appearance">
          <div className="space-y-6">
            <Card className="p-6">
              <ImportanceColorSettings />
            </Card>
          </div>
        </TabsContent>
        
        <TabsContent value="integrations">
          <div className="space-y-6">
            <ExchangeRateSettings />
            <UserCompanyRegisterSettings />
          </div>
        </TabsContent>
      </Tabs>
    </Shell>
  );
}
